import {
  required,
  maxLength,
  minLength,
  regex,
  number,
  email,
} from "react-admin";

export const mobilePhoneValidation = [
  required(),
  maxLength(8),
  number(),
  regex(/^\S*\d{8}$/),
];

export const mobilePhoneNoValidation = [
  required(),
  number(),
  regex(/^\S*\d{1}$/),
];

export const postalCodeValidation = [required(), regex(/^\d{1,12}$/)];

export const emailValidation = [required(), email()];

export const vaNumberValidation = [minLength(11), maxLength(11), number()];

export const calculationCostCreateStudentValidation = (
  formData: formCreateStudent
) => {
  if (
    formData.uniqueCode &&
    formData.firstName &&
    formData.lastName &&
    formData.schoolId &&
    formData.academicYearId &&
    formData.levelId &&
    formData.date &&
    formData.wayType &&
    formData.postalCode &&
    formData.street &&
    (formData.isMonday ||
      formData.isFriday ||
      formData.isThursday ||
      formData.isTuesday ||
      formData.isWednesday)
  ) {
    return false;
  } else {
    return true;
  }
};

export const calculationCostUpdateScheduleValidation = (
  formData: formUpdateSchedule
) => {
  if (
    formData.studentId &&
    formData.academicYearId &&
    formData.startedAt &&
    formData.endedAt
  ) {
    if (!formData.isNotTaking) {
      if (
        formData.street &&
        formData.postalCode &&
        formData.wayType &&
        (formData.isMonday ||
          formData.isFriday ||
          formData.isThursday ||
          formData.isTuesday ||
          formData.isWednesday)
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export const availableOnlySuperAdminAndCustomerServices = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return roles.includes("superadmin") || roles.includes("customerservice");
};

export const availableOnlySuperAdmin = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return roles.includes("superadmin");
};

export const ableCreateManualBankTransferValidation = (values: any) => {
  return (
    values.price &&
    values.description &&
    values.accountingDocumentIds &&
    values.accountingDocumentIds.length > 0
  );
};

export const calculationCostWidgetValidation = (formData: any) => {
  if (
      formData.locationData?.POSTAL &&
      formData.locationData?.LATITUDE &&
      formData.locationData?.LONGITUDE
  ) {
    return false;
  } else {
    return true;
  }
};

export const calculationCostStudentWidgetValidation = (formData: any) => {
  if (
      formData.academicYearId &&
      formData.date &&
      formData.wayType &&
      formData.postalCode &&
      formData.street &&
      (formData.isMonday ||
          formData.isFriday ||
          formData.isThursday ||
          formData.isTuesday ||
          formData.isWednesday)
  ) {
    return false;
  } else {
    return true;
  }
};
